const notifications = {
  state: {
    listNotifications: []
  },
  actions: {
    addNotification({commit}, value) {
      commit('ADD_NOTIFICATION', value)
    },
    removeNotification({commit}, value) {
      commit('REMOVE_NOTIFICATION', value)
    }
  },
  mutations: {
    ADD_NOTIFICATION(state, value) {
      state.listNotifications.push(value)
    },
    REMOVE_NOTIFICATION(state, value) {
      state.listNotifications.splice(value, 1)
    }

  }
}

export default notifications;